import * as stagesCase from "../../Stages/StagesCase";
import { getRequiredFields, validateFields } from "../statusChangeValidators";
import { contractValidators } from "../Contract/contractValidators";
import { DataLeakContract } from "../../../types/Products/ContractLaw/DataLeakContract";

const missingPrimaryCreditAgencyError =
  'Folgende Felder müssen gefüllt sein je nach Datengrundlage. SCHUFA: „Schufa-Auskunft erhalten am“, "Eintragsdatum' +
  ' Schufa ab 25.05.2018" und „Schufa-Auszug Positiveintrag“ + „Datenauskunft negativ geprüft am“ darf nicht gefüllt' +
  " sein. CRIF: „Crif-Auskunft erhalten am“, „Eintragsdatum CRIF ab 25.05.2018“ und „CRIF-Auszug Positiveintrag“ +" +
  " „Datenauskunft negativ geprüft am“ darf nicht gefüllt sein.";
export const dataLeakContractValidators = {
  ...contractValidators,
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (dataLeakCase: DataLeakContract) => {
    let errorMessages = validateFields(
      getRequiredFields(dataLeakCase, stagesCase.STAGE_DATA_COMPLETED_LAWFIRM),
      dataLeakCase
    );
    if (!dataLeakCase.primaryCreditAgency) {
      errorMessages.push(missingPrimaryCreditAgencyError);
    }
    return errorMessages;
  },
  [stagesCase.STAGE_PREPARE_LAWSUIT]: (dataLeakCase: DataLeakContract) => {
    let errorMessages = validateFields(getRequiredFields(dataLeakCase, stagesCase.STAGE_PREPARE_LAWSUIT), dataLeakCase);

    if (!dataLeakCase.primaryCreditAgency) {
      errorMessages.push(missingPrimaryCreditAgencyError);
    }

    return errorMessages;
  },
};
